export const ARTICLE_VIDEO_CONST = {
    tNamespace: "common",
    tPath: {
        warning: "video.format-warning"
    }
}
